'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _comments = require('./comments.html');

var _comments2 = _interopRequireDefault(_comments);

var _comments3 = require('./comments.controller');

var _comments4 = _interopRequireDefault(_comments3);

require('./comments.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var commentsComponent = {
  bindings: {},
  template: _comments2.default,
  controller: _comments4.default,
  controllerAs: "vm"
};

exports.default = commentsComponent;


// WEBPACK FOOTER //
// ./client/app/components/dashboard/comments/comments.component.js